module.exports = __webpack_public_path__ + "img/0Q3C0560_BlackMatted_MockedUp.ed213bbb.jpg";